import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import Backend from 'i18next-http-backend';
import { SUPPORTED_LANGS, isSupportedLang } from '../../constants/languages';

const FALLBACK_LANG = 'ge';
const FALLBACK_LOAD_DELAY_MS = 3000;

const langFromPath = window.location.pathname.split('/')[1];
const pageLang = isSupportedLang(langFromPath) ? langFromPath : FALLBACK_LANG;
const startsWithFallback = pageLang === FALLBACK_LANG;

i18n.use(Backend)
    .use(LanguageDetector)
    .use(initReactI18next)
    .init({
        lng: pageLang,
        fallbackLng: startsWithFallback ? FALLBACK_LANG : false,
        supportedLngs: SUPPORTED_LANGS,
        nsSeparator: false,
        backend: {
            loadPath: '/locales/{{lng}}/translation.json',
        },

        debug: false,
        detection: {
            order: ['path', 'localStorage', 'navigator'],
            lookupFromPathIndex: 0,
            checkWhitelist: true,
            caches: ['localStorage'],
        },
        react: {
            useSuspense: true,
        },
        interpolation: {
            escapeValue: false,
        },
    });

if (!startsWithFallback) {
    const enableFallback = () =>
        i18n.loadLanguages(FALLBACK_LANG).then(() => {
            i18n.options.fallbackLng = [FALLBACK_LANG];
        });

    window.addEventListener(
        'load',
        () => setTimeout(enableFallback, FALLBACK_LOAD_DELAY_MS),
        { once: true },
    );
}

export default i18n;
